import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import React from 'react';

export default function CorporationUsageResource({ resourceList, rootCorporationInfo }) {
    if (Utils.isEmptyArray(resourceList)) return null;
    let isDeskServiceOn = rootCorporationInfo?.limitValue?.deskService === Constant.STATUS_SERVICE_PERMISSION.ON;
    let isKnowledgeServiceOn = rootCorporationInfo?.limitValue?.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON;

    const isNotShowValue = (label) => {
        let isShow = !isDeskServiceOn && [Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_B2C_ID_NUMBER, Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_SUPPORT_COUNTER_NUMBER, Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_PUBLIC_DESK_NUMBER].includes(label);
        return isShow;
    }
    const isShowNumberOfKnowledge = (label) => {
        let isShow = !isKnowledgeServiceOn && [Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_KNOWLEDGE_TICKET_NUMBER].includes(label);
        return isShow;
    }
    return (
        <>
            {resourceList?.map((resource, index) => {
                return (
                    <> {
                        (!isNotShowValue(resource.label) && !isShowNumberOfKnowledge(resource.label)) && (
                            <div className="setting-item setting-item-group border-bottom">
                                <div className="title-parent-tree">
                                    <label className={`${resource.isOverMax && 'text-over-max-warning'} setting-label-tree`}>{I18n.get(resource.label)}</label>
                                    <div className={`${resource.isOverMax && 'text-over-max-warning'}`}>
                                        {resource.value}{' '}
                                        {resource?.maxValue !== undefined && <span>/</span>}{' '}
                                        {resource.maxValue} {resource?.unit}
                                    </div>
                                </div>
                                {!Utils.isEmptyArray(resource.listItems) &&
                                    resource.listItems?.map(itemChild => {
                                        return (
                                            isNotShowValue(itemChild.label) ? <></> : 
                                            <div className="setting-children-item">
                                                <label className="setting-label">
                                                    {I18n.get(itemChild.label)}
                                                </label>
                                                <div className="switch-check">
                                                    {itemChild?.value} {itemChild?.unit}
                                                </div>
                                            </div>    
                                        );
                                    })}
                            </div>
                        )
                    }
                    </>
                );
            })}
        </>
    );
}
